import React from "react";
import LegalPage from "./LegalPage";

export default function Terms() {
  return (
    <LegalPage title="Terms & Conditions" subtitle="Legal" testid="terms-page">
      <p>
        These Terms &amp; Conditions (&quot;Terms&quot;) govern your access to and use of the Breakout Scanner
        application (&quot;Service&quot;, &quot;we&quot;, &quot;us&quot;, &quot;our&quot;) available at{" "}
        <span className="font-mono">breakout-scanner-14.preview.emergentagent.com</span>. By
        creating an account, subscribing, or using any part of the Service, you agree to be bound by these Terms.
      </p>

      <h2>1. Service Description</h2>
      <p>
        Breakout Scanner is an educational market-research tool that scans publicly available price and volume
        data from NSE (National Stock Exchange of India) to identify stocks that have recently broken out of
        their 6-month and 3-year highs. The Service displays suggested entry, stop-loss and target levels,
        sector strength, AI-generated fundamental summaries, and other analytical outputs.
      </p>
      <p className="important">
        <strong>The Service is purely educational. It is not investment, financial, tax or legal advice.</strong>{" "}
        We are not SEBI-registered investment advisers, research analysts, or portfolio managers. Any decision
        to buy, hold or sell a security is yours alone.
      </p>

      <h2>2. Eligibility</h2>
      <ul>
        <li>You must be at least 18 years old and legally competent to enter into a contract under Indian law.</li>
        <li>You must provide accurate registration information and keep your credentials secure.</li>
        <li>You are responsible for all activity that occurs under your account.</li>
      </ul>

      <h2>3. Subscription &amp; Auto-Renewal</h2>
      <ul>
        <li>
          The Service offers a paid subscription: <strong>₹5 trial for 5 days</strong>, which then{" "}
          <strong>auto-renews at ₹299 per month</strong> via Razorpay mandate (UPI / Card / Net-Banking).
        </li>
        <li>
          By starting the trial and completing authentication on the Razorpay checkout, you expressly authorise
          recurring auto-debits of ₹299 per month from your chosen payment method until you cancel.
        </li>
        <li>
          Renewal occurs automatically on the date shown in your Razorpay mandate. A failed payment may place
          your subscription into a halted state; we may retry or suspend Premium access.
        </li>
        <li>
          You may cancel at any time from the in-app <em>Pricing</em> page or from your Razorpay customer
          portal. Cancellation stops future renewals; access continues until the end of the current billing
          cycle.
        </li>
        <li>
          Prices may change; any change will be notified at least 7 days in advance and will apply only to the
          subsequent billing cycle.
        </li>
      </ul>

      <h2>4. Acceptable Use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Re-publish, resell, re-stream or systematically scrape the Service or its content.</li>
        <li>Attempt to reverse-engineer, probe or disrupt the Service or its infrastructure.</li>
        <li>Use the Service for any unlawful purpose or to harm any third party.</li>
      </ul>

      <h2>5. Data &amp; Accuracy Disclaimer</h2>
      <p>
        Market data is sourced from third-party providers (including Yahoo Finance via yfinance) and may be
        delayed, incomplete, or contain errors. We make no warranty as to the accuracy, completeness,
        timeliness or reliability of any signal, price, chart, fundamental summary or AI output. All outputs
        are provided <strong>&quot;as is&quot;</strong> and <strong>&quot;as available&quot;</strong>.
      </p>

      <h2>6. Risk Warning</h2>
      <p>
        Trading in equities carries substantial risk, including the possible loss of the entire invested
        amount. Past performance is not indicative of future results. You should carefully consider your
        financial situation and consult a SEBI-registered adviser before acting on any information shown in
        the Service.
      </p>

      <h2>7. Intellectual Property</h2>
      <p>
        All trademarks, logos, code, text, graphics and design of the Service are owned by Breakout Scanner or
        its licensors. You are granted a limited, non-exclusive, non-transferable licence to access the
        Service for personal, non-commercial use only.
      </p>

      <h2>8. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, Breakout Scanner and its operators shall not be liable for any
        indirect, incidental, consequential, special, exemplary or punitive damages, including any loss of
        profits, trading losses or loss of data, arising out of or in connection with your use of the Service.
        Our aggregate liability for any claim will not exceed the amount you paid us in the 3 months preceding
        the event giving rise to the claim.
      </p>

      <h2>9. Indemnity</h2>
      <p>
        You agree to indemnify and hold harmless Breakout Scanner from any claim or demand made by any third
        party arising out of your breach of these Terms or your violation of any law or the rights of a third
        party.
      </p>

      <h2>10. Termination</h2>
      <p>
        We may suspend or terminate your access at our discretion if you breach these Terms, engage in
        fraudulent or abusive conduct, or if required by law. Accrued subscription fees for terminated
        accounts are non-refundable except as provided in the Refund Policy.
      </p>

      <h2>11. Governing Law &amp; Jurisdiction</h2>
      <p>
        These Terms are governed by the laws of India. Exclusive jurisdiction lies with the courts of your
        registered state of residence or as permitted under the Consumer Protection Act, 2019.
      </p>

      <h2>12. Contact</h2>
      <p>
        Questions? Reach us at <span className="font-mono">breakoutscanner1987@gmail.com</span>.
      </p>
    </LegalPage>
  );
}
